import axios from "axios";
import { api } from "./helper";
import CryptoJS from 'crypto-js';
import Utils from "@/project/Source/utils.js";

const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem('jwt'), 'secret_key').toString(CryptoJS.enc.Utf8));
    return Utils.applyRequestCorrelationId(config);
});

client.interceptors.response.use(
    (response) => {
        if (response.data.isSuccess)
            return response;
        else {
            const message = Utils.FormatErrorWithCorrelationId(null, response);
            Utils.Alert(message);
        }
    },
    (error) => {
        if (error.response?.status === 401) {
            Utils.redirectToLoginOnUnauthorized();
            return Promise.reject(error);
        }
        console.log(error);
        const message = Utils.FormatErrorWithCorrelationId(error);
        Utils.Alert(message);
        return Promise.reject(error);
    }
);


function ClientByName(item) {
    return client.post("Client/ClientByName", item);
}

function DropClientRequest(item) {
    return client.post("Client/DropClientRequest", item);
}

function EditClientRequest(item) {
    return client.post("Client/EditClientRequest", item);
}

function NewClientRequest(item) {
    return client.post("Client/NewClientRequest", item);
}

function ClientById(item) {
    return client.post("Client/ClientById", item);
}

function ClientByType(item) {
    return client.post("Client/ClientByType", item);
}

function ClientPrivvilage(item) {
    return client.post("Client/ClientPrivvilage", item);
}

function ClientByAttribute(item) {
    return client.post("Client/ClientByAttribute", item);
}

function CompanyByAttribute(item) {
    return client.post("Client/CompanyByAttribute", item);
}

function CompanyTypeRelations(item) {
    return client.post("Client/GetCompanyTypeRelations", item);
}

function CompanyTypeRelation(item) {
    return client.post("Client/CompanyTypeRelation", item);
}

function NewCompanyTypeRelationRequest(item) {
    return client.post("Client/NewCompanyTypeRelationRequest", item);
}

function DropCompanyTypeRelationRequest(item) {
    return client.post("Client/DropCompanyTypeRelationRequest", item);
}

function CompanyById(item) {
    return client.post("Client/CompanyById", item);
}

function NewCompanyRequest(item) {
    return client.post("Client/NewCompanyRequest", item);
}

function EditCompanyRequest(item) {
    return client.post("Client/EditCompanyRequest", item);
}

function DropCompanyRequest(item) {
    return client.post("Client/DropCompanyRequest", item);
}

function NewCompanyTypeRequest(item) {
    return client.post("Client/NewCompanyTypeRequest", item);
}

function EditCompanyTypeRequest(item) {
    return client.post("Client/EditCompanyTypeRequest", item);
}

function DropCompanyTypeRequest(item) {
    return client.post("Client/DropCompanyTypeRequest", item);
}

function CompanyType(item) {
    return client.post("Client/CompanyType", item);
}

function OrganizationType(item) {
    return client.post("Client/OrganizationType", item);
}

export default {
    ClientPrivvilage,
    ClientById,
    NewClientRequest,
    ClientByType,
    ClientByName,
    DropClientRequest,
    EditClientRequest,
    ClientByAttribute,
    CompanyByAttribute,
    CompanyTypeRelations,
    CompanyTypeRelation,
    NewCompanyTypeRelationRequest,
    DropCompanyTypeRelationRequest,
    CompanyById,
    NewCompanyRequest,
    EditCompanyRequest,
    DropCompanyRequest,
    NewCompanyTypeRequest,
    EditCompanyTypeRequest,
    DropCompanyTypeRequest,
    CompanyType,
    OrganizationType
}